var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnsIconLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1088.235 840.724 1894.118 1900.452",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(255, 255, 255)",
      paintOrder: "fill",
      strokeOpacity: 0
    },
    cx: 2032.805,
    cy: 1796.606,
    r: 944.57
  }), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(0.922616, 0, 0, -0.922616, 600.50116, 3278.643311)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.139701)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#3d587b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 13687.4,14780.2 5853.78,10252.3 8466.5,8745.59 16300,13273.5 13687.4,14780.2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.139714)",
    id: "g18",
    style: {
      fill: "#d5f6ff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#d5f6ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,10256.6 -1.4,3015.8 -2611,-1509.3 1.6,-3015.7 2610.8,1509.2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.126654)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#5a7b92",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 12217.3,14638.1 -2881.84,1661.9 1.58,-3326.7 2880.26,1664.8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.117336)",
    id: "g26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#5a7b92",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16300,10415.7 -2,3590.9 -3108.7,-1797 3110.7,-1793.9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.126654)",
    id: "g30",
    style: {
      fill: "#aaeeff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#aaeeff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9337.04,12973.3 -1.58,3326.7 -2880.22,-1664.8 1.59,-3326.7 2880.21,1664.8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnsIconLogo);
export default __webpack_public_path__ + "static/media/ensIconLogo.e802751e34d8d973ef3265d56f9b04c3.svg";
export { ForwardRef as ReactComponent };